module.exports = __webpack_public_path__ + "static/media/principle_badge_RGB.9d30f03c.svg";